<template>
  <div class="sidebar-wrapper">
    <nav class="sidebar sidebar-fixed-width bg-light">
      <div class="sidebar-sticky pt-3">
        <ul class="nav flex-column">
          <li class="nav-item">
            <b-link
              class="nav-link"
              to="/dashboard"
            >
              {{ $t('sidebar.dashboardLink') }}
            </b-link>
          </li>
          <h6
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
          >
            <span>{{ $t('sidebar.sectionContracts') }}</span>
            <a
              class="d-flex align-items-center text-muted"
              href="#"
              :aria-label="$t('sidebar.sectionContracts')"
            >
              <span data-feather="plus-circle" />
            </a>
          </h6>
          <li class="nav-item px-2">
            <b-link
              class="nav-link"
              :to="{ name: 'ContractsRoute' }"
            >
              {{ $t('sidebar.contractsLink') }}
            </b-link>
          </li>
          <li class="nav-item px-2">
            <b-link
              class="nav-link"
              :to="{ name: 'GrupareContracteIndexRoute' }"
            >
              {{ $t('sidebar.grupareContracteLink') }}
            </b-link>
          </li>
          <h6
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
          >
            <span>{{ $t('sidebar.sectionAuctions') }}</span>
            <a
              class="d-flex align-items-center text-muted"
              href="#"
              :aria-label="$t('sidebar.sectionAuctions')"
            >
              <span data-feather="plus-circle" />
            </a>
          </h6>
          <li class="nav-item px-2">
            <b-link
              exact
              class="nav-link"
              :to="{ name: 'LicitatieAchizitieIndexRoute' }"
            >
              {{ $t('sidebar.licitatieAchizitieLink') }}
            </b-link>
          </li>
          <li class="nav-item px-2">
            <b-link
              exact
              class="nav-link"
              :to="{ name: 'LicitatieAchizitieReportsRoute' }"
            >
              Rapoarte sintetice
            </b-link>
          </li>
          <h6
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
          >
            <span>{{ $t('sidebar.sectionCatalogs') }}</span>
            <a
              class="d-flex align-items-center text-muted"
              href="#"
              :aria-label="$t('sidebar.sectionCatalogs')"
            >
              <span data-feather="plus-circle" />
            </a>
          </h6>
          <li class="nav-item px-2">
            <b-link
              class="nav-link"
              :to="{ name: 'PartnersIndexRoute' }"
            >
              {{ $t('sidebar.partnersLink') }}
            </b-link>
          </li>
          <h6
            v-if="isInRole(['UserAdmin', 'AppAdmin'])"
            class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted"
          >
            <span>{{ $t('sidebar.sectionAdministration') }}</span>
            <a
              class="d-flex align-items-center text-muted"
              href="#"
              :aria-label="$t('sidebar.sectionAdministration')"
            >
              <span data-feather="plus-circle" />
            </a>
          </h6>
          <li
            v-if="isInRole(['UserAdmin', 'AppAdmin'])"
            class="nav-item px-2"
          >
            <b-link
              class="nav-link"
              :to="{ name: 'ConfigurareAplicatieRoute' }"
            >
              {{ $t('sidebar.configurareAplicatieLink') }}
            </b-link>
          </li>
          <li
            v-if="isInRole(['UserAdmin', 'AppAdmin'])"
            class="nav-item px-2"
          >
            <b-link
              class="nav-link"
              :to="{ name: 'AccesSecuritateRoute' }"
            >
              {{ $t('sidebar.accesSecuritateLink') }}
            </b-link>
          </li>
          <li class="version-label text-center mb-4">
            <small
              v-b-tooltip.hover
              :title="'Versiunea ' + appVersion"
              class="text-muted"
            >
              <b-icon icon="tag" />
              {{ appVersion }}
            </small>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'Sidebar'
})
export default class extends Vue {
  isInRole(roles: string[] | string): boolean {
    return UserModule.isInRole(roles)
  }

  appVersion = process.env.VUE_APP_VERSION || 'b44df00d'
}
</script>
